import React from "react";
import { AllScenarioWeights } from "../../../../../api/apiTypes";

interface TabellaPesiProps {
  scenarioWeights: AllScenarioWeights;
}

const TabellaPesi: React.FC<TabellaPesiProps> = ({ scenarioWeights }) => {
  // righe = fattori / chiavi dell'oggetto
  const headers = Object.keys(scenarioWeights) as (keyof AllScenarioWeights)[];
  
  // colonne = banche
  const banks = Object.keys(scenarioWeights[headers[0]]);

  return (
    <div className="mt-8 p-4 bg-gray-100 rounded-lg shadow-inner overflow-x-auto">
      <h2 className="text-lg font-bold mb-4">TABELLA DEI PESI</h2>
      <table className="min-w-full text-left table-auto border-collapse">
        <thead>
          <tr className="bg-textSecondary text-white text-xs font-semibold uppercase tracking-wider">
            <th className="py-2 px-3 border border-gray-300 text-xs text-center">
              Fattore / Scenario
            </th>
            {banks.map((bank) => (
              <th
                key={bank}
                className="py-2 px-3 border border-gray-300 text-xs text-center"
              >
                {bank}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {headers.map((header) => (
            <tr key={header} className="bg-white even:bg-gray-100 text-xs">
              <td className="py-2 px-3 border border-gray-300 font-semibold">
                {header}
              </td>
              {banks.map((bank) => (
                <td
                  key={bank}
                  className="py-2 px-3 border border-gray-300 text-xs text-center"
                >
                  {(scenarioWeights[header][bank] * 100).toFixed(2)} %
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TabellaPesi;
